export default "__VITE_ASSET__52d691d3__"